import React, { useEffect, useRef } from 'react';
import { MessageBox } from 'react-chat-elements';
import { Ref, Segment } from 'semantic-ui-react';
import './index.scss';
import DateTimeUtils from 'dyl-components/utils/DateTimeUtils';
import { ClippedContent } from 'dyl-components/atoms/ClippedContent';

const getFormatedDate = (ts) => {
    return DateTimeUtils.changeFormat(DateTimeUtils.convertUnixTimeToDate(ts), "", `${DateTimeUtils.WORD_DATE_FORMAT} ${DateTimeUtils.TIME_FORMAT}`)
}


const getStatus = (status) => {
    switch (status) {
        case 'pending':
            return <b className="Text--pending">Pending</b>;

        case 'failed':
            return <b className="Text--failed">Failed</b>;

        default:
            return <></>
    }
}
const SenderTimestamp = ({ sender, ts, status }) => (
    <div className='ChatThread_RenderAddCmp'>
        {sender && <small className='ChatThread_RenderAddCmp--sender'>
            <ClippedContent>
                <b>{sender}</b>
            </ClippedContent>
        </small>}
        <small className='ChatThread_RenderAddCmp--timestamp'>
            {status && status !== 'sent' ? getStatus(status) : getFormatedDate(ts)}
        </small>
    </div>
)

const ChatThread = ({ messages, isReadingMessages, height = '312px', disabled }) => {
    const ref = useRef(null);
    useEffect(() => {
        if (!isReadingMessages && ref.current) {
            ref.current.scrollTo({
                top: ref.current.scrollHeight
            })
        }
    }, [isReadingMessages]);
    return (
        <Ref innerRef={ref}>
            <Segment loading={isReadingMessages} className={`ChatThread ${disabled ? 'ChatThread--disabled' : ''}`} basic style={{ height }}>
                {messages.slice(0).sort((a, b) => a.ts - b.ts).map(message => {
                    const senderTimestamp = <SenderTimestamp sender={message.sender} ts={message.ts} status={message?.status} />;
                    return (
                        <div className={`${message?.status === 'failed' ? 'ChatThread--failed' : message?.is_campaign ? 'ChatThread--campaign' : ''} ChatThread__message-item`}>
                            {message.message && (
                                <MessageBox
                                    notch={false}
                                    position={message.direction === 'outbound' ? 'right' : 'left'}
                                    type={'text'}
                                    text={message.message}
                                    renderAddCmp={() => (
                                        message?.attachments?.length <= 0 && message.direction === 'outbound' && senderTimestamp
                                    )} />

                            )}
                            {message.attachments?.map((attachment, index) => {
                                const type = attachment.type;
                                const data = (() => {
                                    const uri = attachment.uri;
                                    if (type === 'video') {
                                        return {
                                            videoUrl: uri,
                                            uri,
                                            status: {
                                                click: true,
                                                loading: 0.5,
                                                download: true
                                            }
                                        }
                                    }
                                    if (type === 'audio') {
                                        return { audioUrl: uri }
                                    }
                                    return {
                                        uri,
                                        width: 200,
                                        height: 200
                                    }
                                })();
                                return (
                                    <MessageBox
                                        notch={false}
                                        position={message.direction === 'outbound' ? 'right' : 'left'}
                                        type={attachment.type}
                                        text={attachment.name}
                                        data={data}
                                        renderAddCmp={() => (
                                            index === message.attachments.length - 1 && message.direction === 'outbound' && senderTimestamp
                                        )}
                                        onClick={e => {
                                            e.preventDefault();
                                            window.open(attachment.uri, '_blank');
                                        } } />
                                );
                            })}
                            {message.direction !== 'outbound' && <div className={`ChatThread__message-timestamp ChatThread__message-timestamp--left`}>
                                <small>
                                    {getFormatedDate(message.ts)}
                                </small>
                            </div>}

                        </div>
                    );
                })}
            </Segment>
        </Ref>
    );
};

export default ChatThread;
